/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyExternalSystemAccess,
    ReadOnlyExternalSystemAccessFromJSON,
    ReadOnlyExternalSystemAccessFromJSONTyped,
    ReadOnlyExternalSystemAccessToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20012
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20012
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20012
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyExternalSystemAccess>}
     * @memberof InlineResponse20012
     */
    results: Array<ReadOnlyExternalSystemAccess>;
}

export function InlineResponse20012FromJSON(json: any): InlineResponse20012 {
    return InlineResponse20012FromJSONTyped(json, false);
}

export function InlineResponse20012FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20012 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyExternalSystemAccessFromJSON)),
    };
}

export function InlineResponse20012ToJSON(value?: InlineResponse20012 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyExternalSystemAccessToJSON)),
    };
}


